import { Popover } from '@headlessui/react';
import ChevronUp from 'svg/ChevronUp';
import classNames from 'styles/utils/classNames';
import { SortByEnum } from '../enums';
import { sortOptions } from '../utils';

interface SortDropdownProps {
  sortBy: SortByEnum;
  setSortBy: React.Dispatch<React.SetStateAction<SortByEnum>>;
  wrapperClassName?: string;
}

const SortDropdown: React.FC<SortDropdownProps> = ({ sortBy, setSortBy, wrapperClassName }) => {
  return (
    <div className={classNames('flex items-center gap-2', wrapperClassName)}>
      <span className="typography-product-caption shrink-0 whitespace-nowrap text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary max-md:hidden">
        Sort:
      </span>
      <Popover className={'relative max-md:w-full'}>
        {({ open, close }) => (
          <>
            {/*adding small margin to account for line height */}
            <Popover.Button className="typography-product-button-label-medium flex w-[11.25rem] items-center justify-between gap-2 bg-color-bg-input-lightmode-primary px-4 py-3 dark:bg-color-bg-darkmode-primary max-md:w-full md:rounded-full">
              <span className="typography-product-button-label-medium max-sm:text-color-text-lightmode-placeholder max-sm:dark:text-color-text-darkmode-placeholder">
                {sortOptions.find((option) => option.value === sortBy)?.label}
              </span>
              <ChevronUp
                className={classNames(
                  'h-4 w-4 shrink-0 rotate-180 transition-transform',
                  open && '!rotate-0',
                )}
              />
            </Popover.Button>
            <Popover.Panel
              className={
                'absolute z-10 mt-2 w-full rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary p-ds-md shadow-lg dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary'
              }
            >
              <div className="flex flex-col gap-1">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      setSortBy(option.value);
                      close();
                    }}
                    className={classNames(
                      'typography-product-button-label-medium rounded-xl border border-transparent p-ds-md text-left text-color-text-lightmode-secondary transition-all hover:border-color-bg-lightmode-icon dark:text-color-text-darkmode-secondary    hover:dark:border-color-bg-darkmode-icon ',
                      sortBy === option.value &&
                        '!border-color-bg-lightmode-icon dark:!border-color-bg-darkmode-icon',
                    )}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default SortDropdown;
